// extracted by mini-css-extract-plugin
export default {"cls1":"VeloStepperIcon-Skeleton_cls1__3FrlU","cls2":"VeloStepperIcon-Skeleton_cls2__WpCYA VeloStepperIcon-Skeleton_cls1__3FrlU"};